import { z } from 'zod';

import { YARD_STAGES, YardStageSchema } from './yard-stages.js';

export const YardColumnConfigSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  stage: YardStageSchema.nullable(),
  name: z.string(),
  color: z.string(),
  position: z.number().int(),
  boundaryTransition: YardStageSchema.nullable(),
});
export type YardColumnConfig = z.infer<typeof YardColumnConfigSchema>;

export const ListYardColumnConfigsResponseSchema = z.object({
  columns: z.array(YardColumnConfigSchema),
});
export type ListYardColumnConfigsResponse = z.infer<typeof ListYardColumnConfigsResponseSchema>;

/** Body kept for OpenAPI compatibility; create/update/delete always reject (BR-SO-203). */
export const CreateYardColumnConfigBodySchema = z.object({
  stage: z.enum(YARD_STAGES).nullable().optional(),
  name: z.string().min(1).max(100),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .optional(),
  boundaryTransition: z.enum(YARD_STAGES).nullable().optional(),
});
export type CreateYardColumnConfigBody = z.infer<typeof CreateYardColumnConfigBodySchema>;

export const UpdateYardColumnConfigBodySchema = z.object({
  name: z.string().min(1).max(100).optional(),
  color: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .optional(),
  position: z.number().int().min(0).optional(),
});
export type UpdateYardColumnConfigBody = z.infer<typeof UpdateYardColumnConfigBodySchema>;

export const MoveYardCardOriginSchema = z.enum(['BOARD', 'SERVICE_ORDER_SCREEN']);
export type MoveYardCardOrigin = z.infer<typeof MoveYardCardOriginSchema>;

export const MoveYardCardBodySchema = z.object({
  targetStage: YardStageSchema,
  kind: z.enum(['APPOINTMENT', 'RECEPTION']).optional(),
  origin: MoveYardCardOriginSchema.optional(),
});
export type MoveYardCardBody = z.infer<typeof MoveYardCardBodySchema>;

export const MoveYardCardResponseSchema = z.object({
  kind: z.enum(['APPOINTMENT', 'RECEPTION']),
  cardId: z.uuid(),
  stage: YardStageSchema,
  receptionId: z.uuid().nullable(),
  serviceOrderId: z.uuid().nullable(),
  quoteId: z.uuid().nullable(),
});
export type MoveYardCardResponse = z.infer<typeof MoveYardCardResponseSchema>;
